import React from 'react'

export type SvgIconProps = {
  fill?: string
  className?: string
  width?: string
  height?: string
  stroke?: string
}

const SvgHomeIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="19"
    fill="none"
    viewBox="0 0 20 19"
  >
    <path
      fill={fill ?? "#353535"}
      d="M19.653 8.674L10.566.207C10.37.103 10.175 0 9.98 0c-.196 0-.391.103-.587.207L.307 8.674c-.391.31-.391.93-.098 1.342.195.207.39.31.684.31.195 0 .39-.103.586-.206l.782-.723v7.848c0 1.032.684 1.755 1.66 1.755h12.312c.88 0 1.66-.826 1.66-1.755V9.397l.782.723c.196.103.391.206.587.206.293 0 .488-.103.684-.31.097-.413.097-.929-.293-1.342zm-8.5 3.614H8.806c-.88 0-1.66.826-1.66 1.755v3.098H3.921V7.848l6.058-5.68 6.057 5.68v9.293h-3.224v-3.097c0-.93-.782-1.756-1.66-1.756zm-.099 1.962v2.891h-2.15V14.25h2.15z"
    ></path>
  </svg>
)


export default SvgHomeIcon
